"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaHeader = void 0;
var react_1 = __importDefault(require("react"));
var FaHeader = function () {
    return (react_1.default.createElement("div", { className: "top" },
        react_1.default.createElement("h2", null, "!SHOP"),
        react_1.default.createElement("img", { src: "https://res.cloudinary.com/dut4cl45k/image/upload/v1680167031/lock_buns5a.png", alt: "Lock icon" })));
};
exports.FaHeader = FaHeader;
exports.default = exports.FaHeader;
